var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsteact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 70,
    viewBox: "0 0 157 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34.556C17.1666 30.6804 30.6804 17.1666 34.556 0C38.4315 17.1666 51.9453 30.6804 69.1119 34.556C51.9453 38.4315 38.4315 51.9453 34.556 69.1119C30.6804 51.9453 17.1666 38.4315 0 34.556Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1118 34.5559C93.7925 32.1446 102.2 23.7367 104.612 13.056C107.023 23.7367 115.431 32.1446 126.112 34.5559C115.431 36.9672 107.023 45.3752 104.612 56.056C102.2 45.3752 93.7925 36.9673 83.1118 34.5559Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.112 34.556C144.307 33.609 147.609 30.3067 148.556 26.1119C149.503 30.3067 152.805 33.609 157 34.556C152.805 35.5031 149.503 38.8053 148.556 43.0001C147.609 38.8053 144.307 35.5031 140.112 34.556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsteact);
export default __webpack_public_path__ + "static/media/absteact.8e4fd9b1c77f3db057a1377be5470a7f.svg";
export { ForwardRef as ReactComponent };